import React from 'react';
import { useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { diagnostico } from '../sortilegioContent';

const Diagnostico = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 8, md: 10 }}>
      <SectionHeader
        overline={diagnostico.overline}
        title={diagnostico.title}
        subtitle={diagnostico.intro}
        icon="explore"
        align="left"
        maxWidth="100%"
      />

      <Grid container spacing={3} mb={4}>
        {diagnostico.pillars.map((item, index) => (
          <Grid item xs={12} md={4} key={item.id}>
            <GlassCard data-aos="fade-up" accentPalette={index === 1 ? 'secondary' : 'primary'}>
              <CardContent sx={{ p: 3 }}>
                <Box mb={2}>
                  <IconBadge
                    icon={item.icon}
                    color={index === 1 ? 'secondary' : 'primary'}
                    variant="gradient"
                    size={44}
                    rounded="12px"
                  />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5, lineHeight: 1.3 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary" sx={{ lineHeight: 1.75 }}>
                  {item.text}
                </Typography>
              </CardContent>
            </GlassCard>
          </Grid>
        ))}
      </Grid>

      <Box
        data-aos="fade-up"
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          bgcolor: theme.palette.secondary.dark,
          color: theme.palette.common.white,
        }}
      >
        <Typography variant="overline" sx={{ fontWeight: 800, letterSpacing: 1.4, opacity: 0.85 }}>
          La oportunidad
        </Typography>
        <Typography variant="h6" component="p" sx={{ fontWeight: 500, lineHeight: 1.7, mt: 1 }}>
          {diagnostico.opportunity}
        </Typography>
      </Box>
    </Box>
  );
};

export default Diagnostico;
